import "./_snowpack/pkg/antd/dist/reset.css";
import React, {Suspense} from "./_snowpack/pkg/react.js";
import ReactDOM from "./_snowpack/pkg/react-dom.js";
import {App} from "./App.js";
import {QueryParamProvider} from "./_snowpack/pkg/use-query-params.js";
import "./i18n.js";
import "./index.css";
import {LoadingOutlined} from "./_snowpack/pkg/@ant-design/icons.js";
import {ConfigProvider} from "./_snowpack/pkg/antd.js";
const url = new URL(window.location.href);
if (url.searchParams.has("enc")) {
  const pars = url.searchParams.get("enc") ?? "";
  const decoded = decodeURIComponent(pars);
  window.location.search = decoded;
}
ReactDOM.render(/* @__PURE__ */ React.createElement(Suspense, {
  fallback: /* @__PURE__ */ React.createElement("div", {
    className: "container"
  }, /* @__PURE__ */ React.createElement(LoadingOutlined, {
    style: {fontSize: 32},
    spin: true
  }))
}, /* @__PURE__ */ React.createElement(QueryParamProvider, null, /* @__PURE__ */ React.createElement(ConfigProvider, {
  theme: {hashed: false}
}, /* @__PURE__ */ React.createElement(App, null)))), document.getElementById("root"));
